import { Instagram, Facebook, Youtube, Twitter, Linkedin, Mail, MessageCircle, Music, Globe } from "lucide-react";

// Platform catalog: icon + defaults for UI
export const PLATFORMS = {
  instagram: { label: "Instagram", icon: Instagram, placeholder: "https://instagram.com/tu_cuenta", color: "#E4405F" },
  facebook: { label: "Facebook", icon: Facebook, placeholder: "https://facebook.com/tu_pagina", color: "#1877F2" },
  x: { label: "X (Twitter)", icon: Twitter, placeholder: "https://x.com/tu_cuenta", color: "#000000" },
  youtube: { label: "YouTube", icon: Youtube, placeholder: "https://youtube.com/@tu_canal", color: "#FF0000" },
  tiktok: { label: "TikTok", icon: Music, placeholder: "https://tiktok.com/@tu_cuenta", color: "#000000" },
  linkedin: { label: "LinkedIn", icon: Linkedin, placeholder: "https://linkedin.com/company/tu_pagina", color: "#0A66C2" },
  whatsapp: { label: "WhatsApp", icon: MessageCircle, placeholder: "https://wa.me/34XXXXXXXXX", color: "#25D366" },
  email: { label: "Email", icon: Mail, placeholder: "mailto:info@pequenofresno.net", color: "#4d6a3a" },
  other: { label: "Otro", icon: Globe, placeholder: "https://...", color: "#4d6a3a" },
};

export function getPlatformMeta(key) {
  return PLATFORMS[key] || PLATFORMS.other;
}
